/* @flow */
import {
  UNDO,
  REDO,
  RESET,
  FETCH,
  FETCH_EXPLOSION,
  CLEAR,
  TOGGLE_NODE,
  NODE_CLICKED,
  DELETE_NODES,
  REPLACE_SELECTION,
  SET_FILTERS,
  SET_OPTIONS,
  SET_HOVERED_NODE_ID,
  SET_ROOT_NODE_ID,
  UPDATE_TIME_RANGE,
  EXPORT_INDICATORS,
  CLOSE_TIME_RANGE_EXPLANATION,
  CACHE_GRAPH_SIMULATION,
  SAVE_NOTE,
  UPDATE_NOTE,
  DELETE_NOTE,
  HIGHLIGHT_NODE,
  RESET_HIGHLIGHT_NODE,
  ADD_BREADCRUMB,
  GO_TO_BREADCRUMB,
  RESET_BREADCRUMBS,
} from './action-types.js';
import type { ConstellationOptions, FetchPayload, FiltersPayload } from './types.js';
import typeof { Filters } from 'trustar/constellation/graph-utils.js';

export const clear = () => ({ type: CLEAR });

export const fetch = (payload: FetchPayload) => ({
  type: FETCH,
  payload,
});

export const closeTimeRangeExplanation = () => ({
  type: CLOSE_TIME_RANGE_EXPLANATION,
});

/* Toggle a node within our current selection of nodes. */
export const toggleNodeSelection = (nodeId: ?string): Object => ({
  type: TOGGLE_NODE,
  payload: nodeId,
});

export const captureNodeClicked = (node: ForceNode): Object => ({
  type: NODE_CLICKED,
  payload: node
});

export const replaceNodeSelection = (nodeIds: string[]): Object => ({
  type: REPLACE_SELECTION,
  payload: nodeIds,
});

export const setHoveredNodeId = (nodeId: ?string): Object => ({
  type: SET_HOVERED_NODE_ID,
  payload: nodeId,
});

// this isn't used anywhere?
export const setRootReportNodeId = (nodeId: ?string): Object => ({
  type: SET_ROOT_NODE_ID,
  payload: nodeId,
});

export const fetchExplosion = (node: ForceNode) => ({
  type: FETCH_EXPLOSION,
  payload: node,
});

export const setOptions = (options: ConstellationOptions): Object => ({
  type: SET_OPTIONS,
  payload: options,
});

export const filterText = (filters: Filters, id: string) => ({
  type: SET_FILTERS,
  payload: { id, filters },
});

export const toggleActiveFilter = (filter: FiltersPayload): Object => ({
  type: SET_FILTERS,
  payload: filter,
});

export const undo = () => ({ type: UNDO });

export const redo = () => ({ type: REDO });

export const resetCurrentGraph = () => ({ type: RESET });

export const deleteCurrentSelection = () => ({ type: DELETE_NODES });

export const exportCurrentGraphIndicatorsInCSV = () => ({ type: EXPORT_INDICATORS });

export const updateGraphTimeRange = (timeRange: [number, number], id: string) => {
  return { type: UPDATE_TIME_RANGE, payload: { id, data: timeRange } };
};

export const cacheGraphSimulation = (simulation: ForceSimulation) => ({
  type: CACHE_GRAPH_SIMULATION,
  payload: simulation,
});

export const saveNote = (payload: Object) => ({
  type: SAVE_NOTE,
  payload,
});

export const updateNote = (payload: Object) => ({
  type: UPDATE_NOTE,
  payload,
});

export const deleteNote = (note: Object) => ({
  type: DELETE_NOTE,
  payload: note,
});

export const highlightNode = (payload?: Object) => ({
  type: HIGHLIGHT_NODE,
  payload
});
export const resetHighlightedNode = (payload?: Object) => ({
  type: RESET_HIGHLIGHT_NODE,
  payload
});
export const resetBreadcrumbs = () => ({
  type: RESET_BREADCRUMBS,
});
export const goToBreadcrumb = (payload: Object) => ({
  type: GO_TO_BREADCRUMB,
  payload
});
export const addBreadcrumb = (payload: Object) => ({
  type: ADD_BREADCRUMB,
  payload
});



// WEBPACK FOOTER //
// ./src/app/modules/constellation/actions.js